import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import FeaturedDestinations from './components/FeaturedDestinations';
import PopularTours from './components/PopularTours';
import TestimonialsSection from './components/TestimonialsSection';
import MapExplorer from './components/MapExplorer';
import RecentBookings from './components/RecentBookings';
import NewsletterSection from './components/NewsletterSection';
import Footer from './components/Footer';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main>
        <HeroSection />
        <FeaturedDestinations />
        <PopularTours />
        <TestimonialsSection />
        <MapExplorer />
        <NewsletterSection />
      </main>
      
      <Footer />
      <RecentBookings />
    </div>
  );
};

export default Homepage;